export default {
  office: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'المكتب والعيادة',
    hero: {
      eyebrow: 'المكتب والعيادة',
      title: 'مراقبة سرية لبيئات العمل',
      lead: 'الاستقبال والممرات والمناطق الحساسة – نخطط أنظمة كاميرات تحمي دون إقلاق الموظفين أو المرضى.',
    },
    areas: {
      title: 'مجالات الاستخدام في المكاتب والعيادات',
      lead: 'تحتاج المكاتب والعيادات الحديثة إلى تقنية أمان غير لافتة. ندمج الكاميرات بذكاء في الهندسة المعمارية.',
      items: {
        '0': { title: 'الاستقبال', desc: 'الانطباع الأول وأول نقطة مراقبة. كاميرات الاستقبال توثّق الزوار وتؤمّن الدخول.' },
        '1': { title: 'الممرات', desc: 'الممرات الطويلة غالبًا نقاط عمياء. كاميرات سقف مدمجة تسد الفجوات دون لفت النظر.' },
        '2': { title: 'قاعات الاجتماعات', desc: 'ليست كل اجتماعات تحتاج للتسجيل. نُعدّ الكاميرات لتغطي المناطق ذات الصلة فقط.' },
        '3': { title: 'غرفة الخوادم', desc: 'الغرفة التي تحوي بياناتك تستحق اهتمامًا خاصًا. يُسجَّل الدخول والنشاط بموثوقية.' },
        '4': { title: 'استقبال العيادة', desc: 'في العيادات تهم السرية. نركّب كاميرات هادئة لا تقلق المرضى وتحمي المناطق الحساسة.' },
        '5': { title: 'موقف السيارات والمدخل', desc: 'المواقف الخارجية والمداخل معرضة للخطر ليلًا. كاميرات مقاومة برؤية ليلية تراقب.' },
      },
    },
    access: {
      eyebrow: 'الدخول والتحكم',
      title: 'من يمكنه رؤية ماذا؟',
      lead: 'لا يُقبل نظام الكاميرات في المكتب إلا إذا كانت الحقوق واضحة. نُعدّ حقوق وصول متمايزة ونوثّق كل استخدام.',
      items: {
        '0': { title: 'إدارة المستخدمين', desc: 'يحصل كل شخص على الحقوق التي يحتاجها بالضبط – من العرض المباشر إلى إعادة التشغيل.' },
        '1': { title: 'إخفاء المناطق الخاصة', desc: 'مناطق مثل غرف الاستراحة أو غرف الملابس تُخفى تقنيًا في الكاميرا أو المسجّل.' },
        '2': { title: 'سجل الأحداث', desc: 'من شاهد ماذا ومتى؟ سجل وصول كامل يوفر تحكمًا قابلًا للتتبع.' },
      },
    },
    privacy: {
      eyebrow: 'حماية البيانات',
      title: 'حماية البيانات في مكان العمل',
      lead: 'يتمتع الموظفون والزوار بحماية خاصة. ننفّذ مراقبتك بشكل متوافق وعادل – وننصحك في توثيق الضرورة.',
      list: {
        '0': 'التسجيل فقط حيثما كان ضروريًا تشغيليًا',
        '1': 'وضع لافتات للموظفين والزوار',
        '2': 'لا مراقبة لغرف الملابس أو المراحيض أو الاستراحة',
        '3': 'الوصول إلى التسجيلات للمصرح لهم فقط',
        '4': 'توثيق الضرورة التشغيلية',
      },
      note: 'ملاحظة: تخضع مراقبة أماكن العمل لمتطلبات قانونية صارمة. ننصحك تقنيًا دون أن نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'سري. يراعي الخصوصية. موثوق.',
      lead: 'نخطط نظام مكتبك أو عيادتك ليحمي دون إزعاج في الحياة اليومية. دون التزام وبشفافية.',
      primary: 'احجز موعد استشارة',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
};